import { type TPagination } from '@core/models'
import { convertAudioPaginated } from '@core/converters'

import type { TCollectionItemsPaginated } from '@core/api'
import { useCollectionScreenLoaderData } from './useCollectionScreenLoaderData'

const EMPTY_PAGINATION: TPagination = { total: 0, pages: 0, page: 1, size: 0 }
const EMPTY_AUDIO_PAGINATED: TCollectionItemsPaginated = { items: [], pagination: EMPTY_PAGINATION }

// A missing loader payload normalizes to an empty list + zeroed pagination.
export const useCollectionScreenAudios = () => {
    const { audios } = useCollectionScreenLoaderData()
    return convertAudioPaginated(audios || EMPTY_AUDIO_PAGINATED)
}
